module.exports = __webpack_public_path__ + "img/terminal.329b4635.svg";